import { render, staticRenderFns } from "./DomainGroups.vue?vue&type=template&id=7edb9cb1&"
import script from "./DomainGroups.vue?vue&type=script&lang=js&"
export * from "./DomainGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports